import React, {useEffect, useState} from 'react'
import {Link, useLocation, useNavigate} from 'react-router-dom'
import {EvaArrowIosBackFill} from './icons/BackButton'
import LeadServiceAPI from '../../../api/LeadServiceAPI'
import {toast} from 'react-toastify'

export default function SelectRecipients() {
  const role = JSON.parse(localStorage.getItem('kt-auth-react-v') || {})?.data?.role?.role_id
  const location = useLocation()
  const {campaignData} = location.state || {}
  const navigate = useNavigate()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [selectedOption, setSelectedOption] = useState('')
  const [searchQuery, setSearchQuery] = useState('')
  const [recipients, setRecipients] = useState([])
  const [checkedRecipientIds, setCheckedRecipientIds] = useState([])
  const [message, setMessage] = useState('')
  const [receptionType, setReceptionType] = useState(0)
  const [currentPage, setCurrentPage] = useState(1)
  const recipientsPerPage = 5 // Number of recipients to display per page
  // State variables for error messages
  const [recipientError, setRecipientError] = useState('')
  const [messageError, setMessageError] = useState('')

  useEffect(() => {
    if (selectedOption) {
      fetchRecipients(selectedOption)
    }
  }, [selectedOption])

  const fetchRecipients = async (option) => {
    switch (option) {
      case 'All':
        setReceptionType(0)
        if (role === 1 || role === 2) {
          let data = {
            limit: 10000000000,
            offset: 0,
          }
          LeadServiceAPI.getAllContactList(data).then(
            (res) => {
              if (res?.data?.success) {
                setRecipients(res?.data?.data)
              } else {
                setRecipients([])
                toast.error(res?.data?.message, {theme: 'dark'})
              }
            },
            (err) => {
              toast.error(err?.response?.data?.message, {theme: 'dark'})
            }
          )
        } else if (role === 3 || role === 4) {
          let data = {
            limit: 1000000000000,
            offset: 0,
          }
          LeadServiceAPI.getContactListIndividual(data).then(
            (res) => {
              if (res?.data?.success) {
                setRecipients(res?.data?.data)
              } else {
                setRecipients([])
              }
            },
            (err) => {
              toast.error(err?.response?.data?.message, {theme: 'dark'})
            }
          )
        }
       
        break
      case 'Companies':
        setReceptionType(1)
        if (role === 1 || role === 2) {
          let data = {
            limit: 100000000000,
            offset: 0,
          }
          LeadServiceAPI.getAllCompanyList(data).then(
            (res) => {
              if (res?.data?.success) {
                setRecipients(res?.data?.data)
              } else {
                setRecipients([])
                toast.error(res?.data?.message, {theme: 'dark'})
              }
            },
            (err) => {
              toast.error(err?.response?.data?.message, {theme: 'dark'})
            }
          )
        } else if (role === 3 || role === 4) {
          let data = {
            limit: 100000000000,
            offset: 0,
          }
          LeadServiceAPI.getCompanyListIndividual(data).then(
            (res) => {
              if (res?.data?.success) {
                setRecipients(res?.data?.data)
              } else {
                setRecipients([])
              }
            },
            (err) => {
              toast.error(err?.response?.data?.message, {theme: 'dark'})
            }
          )
        }

        break
      case 'Customers':
        setReceptionType(2)
        if (role === 1 || role === 2) {
          let data = {
            limit: 10000000000000,
            offset: 0,
          }
          LeadServiceAPI.getAllCustomerList(data).then(
            (res) => {
              if (res?.data?.success) {
                setRecipients(res?.data?.data)
              } else {
                setRecipients([])
                toast.error(res?.data?.message, {theme: 'dark'})
              }
            },
            (err) => {
              toast.error(err?.response?.data?.message, {theme: 'dark'})
            }
          )
        } else if (role === 3 || role === 4) {
          let data = {
            limit: 100000000000,
            offset: 0,
          }
          LeadServiceAPI.getCustomerListIndividual(data).then(
            (res) => {
              if (res?.data?.success) {
                setRecipients(res?.data?.data)
              } else {
                setRecipients([])
              }
            },
            (err) => {
              toast.error(err?.response?.data?.message, {theme: 'dark'})
            }
          )
        }

        break
      case 'Leads':
        setReceptionType(3)
        if (role === 1 || role === 2) {
          let data = {
            limit: 10000000000,
            offset: 0,
          }
          LeadServiceAPI.getAllLeadList(data).then(
            (res) => {
              if (res?.data?.success) {
                setRecipients(res?.data?.data)
              } else {
                setRecipients([])
              }
            },
            (err) => {
              toast.error(err?.response?.data?.message, {theme: 'dark'})
            }
          )
        } else if (role === 3 || role === 4) {
          let data = {
            limit: 100000000000000,
            offset: 0,
          }
          LeadServiceAPI.getLeadListIndividual(data).then(
            (res) => {
              if (res?.data?.success) {
                setRecipients(res?.data?.data)
              } else {
                setRecipients([])
              }
            },
            (err) => {
              toast.error(err?.response?.data?.message, {theme: 'dark'})
            }
          )
        }

        break
      default:
        setRecipients([])
        return
    }
  }

  const handleOptionChange = (e) => {
    setSelectedOption(e.target.value)
    if (e.target.value !== '') {
      setIsModalOpen(true)
    }
  }

  const closeModal = () => {
    setIsModalOpen(false)
    setSearchQuery('')
    setCurrentPage(1)
  }

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value)
    setCurrentPage(1) // Reset to first page on search
  }

  const handleRecipientToggle = (recipientId) => {
    setCheckedRecipientIds((prevCheckedIds) =>
      prevCheckedIds.includes(recipientId)
        ? prevCheckedIds.filter((id) => id !== recipientId)
        : [...prevCheckedIds, recipientId]
    )
  }

  const filteredRecipients = recipients.filter(
    (recipient) =>
      recipient.name && recipient.name.toLowerCase().includes(searchQuery.toLowerCase())
  )

  // Pagination logic
  const indexOfLastRecipient = currentPage * recipientsPerPage
  const indexOfFirstRecipient = indexOfLastRecipient - recipientsPerPage
  const currentRecipients = filteredRecipients.slice(indexOfFirstRecipient, indexOfLastRecipient)
  const totalPages = Math.ceil(filteredRecipients.length / recipientsPerPage)

  const handleClick = (pageNumber) => {
    setCurrentPage(pageNumber)
  }

  const renderPageNumbers = () => {
    const pageNumbers = []
    for (let i = 1; i <= totalPages; i++) {
      pageNumbers.push(
        <button
          key={i}
          onClick={() => handleClick(i)}
          style={{
            padding: '5px 10px',
            margin: '0 5px',
            borderRadius: '5px',
            backgroundColor: i === currentPage ? '#095157' : '#f1f1f1',
            color: i === currentPage ? 'white' : 'black',
            border: 'none',
            cursor: 'pointer',
          }}
        >
          {i}
        </button>
      )
    }
    return pageNumbers
  }

  const handleCreateList = () => {
    console.log('Selected Recipient IDs:', checkedRecipientIds)
    closeModal()
  }

  // Validation for checkedRecipientIds and textarea
  const handleNextClick = () => {
    // Reset error messages
    setRecipientError('')
    setMessageError('')

    let hasError = false

    // Validate recipients
    if (checkedRecipientIds.length === 0) {
      setRecipientError('Please select at least one recipient.')
      hasError = true
    }

    // Validate message
    if (message.trim() === '') {
      setMessageError('Please enter a message for the recipients.')
      hasError = true
    }

    if (!hasError) {
      // Proceed to next step
      navigate('/campaign/confirmation-campaign-period', { state: { description: campaignData.description, route:campaignData.route,title:campaignData.title,ids:checkedRecipientIds,message:message,reception_type:receptionType}})
    }
  }

  return (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          cursor: 'pointer',
          alignContent: 'center',
          alignItems: 'center',
          justifyContent: 'flex-start',
        }}
        onClick={() => navigate(-1)}
      >
        <div style={{padding: 5, backgroundColor: 'white', borderRadius: 100, marginRight: 5}}>
          <EvaArrowIosBackFill />
        </div>
        <p style={{fontSize: 14, fontWeight: 'bold', margin: 0}}>Back</p>
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          paddingRight: 30,
          paddingLeft: 50,
          marginTop: 20,
        }}
      >
        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
          <p
            style={{
              backgroundColor: '#B0B0B0',
              borderRadius: 50,
              paddingRight: 10,
              paddingLeft: 10,
              paddingTop: 5,
              paddingBottom: 5,
              color: 'white',
              fontWeight: 'bold',
            }}
          >
            1
          </p>
          <p style={{fontSize: 14, marginLeft: 5, color: '#B0B0B0'}}>Create Campaign</p>
        </div>

        <hr style={{width: 170, marginLeft: 5, marginRight: 5, color: '#B0B0B0'}} />
        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
          <p
            style={{
              backgroundColor: '#2ABD84',
              borderRadius: 50,
              paddingRight: 10,
              paddingLeft: 10,
              paddingTop: 5,
              paddingBottom: 5,
              color: 'white',
              fontWeight: 'bold',
            }}
          >
            2
          </p>
          <p style={{fontSize: 14, marginLeft: 5, color: '#2ABD84'}}>Select Recipients</p>
        </div>

        <hr style={{width: 170, marginLeft: 5, marginRight: 5, color: '#2ABD84'}} />
        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
          <p
            style={{
              backgroundColor: '#B0B0B0',
              borderRadius: 50,
              paddingRight: 10,
              paddingLeft: 10,
              paddingTop: 5,
              paddingBottom: 5,
              color: 'white',
              fontWeight: 'bold',
            }}
          >
            3
          </p>
          <p style={{fontSize: 14, marginLeft: 5}}>Campaign Periods</p>
        </div>

        <hr style={{width: 170, marginLeft: 5, marginRight: 5}} />
        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
          <p
            style={{
              backgroundColor: '#B0B0B0',
              borderRadius: 50,
              paddingRight: 10,
              paddingLeft: 10,
              paddingTop: 5,
              paddingBottom: 5,
              color: 'white',
              fontWeight: 'bold',
            }}
          >
            4
          </p>
          <p style={{fontSize: 14, marginLeft: 5}}>Confirm</p>
        </div>
      </div>
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          flexDirection: 'row',
          marginLeft: 30,
          marginRight: 30,
          marginTop: 10,
          backgroundColor: 'white',
          paddingRight: 30,
          paddingLeft: 30,
          paddingTop: 60,
          paddingBottom: 60,
          borderRadius: 10,
        }}
      >
        <div className='col-lg-6 col-12 mb-10'>
          <div style={{padding: 15}}>
            <h2 style={{fontSize: 36, color: '#736F6F', textAlign: 'justify', marginBottom: 20}}>
              Select Recipients
            </h2>
            <p style={{fontSize: 16, color: '#898484'}}>
              Campaigns are used to setup broadcast to reach existing contacts, Leads and company...
            </p>
            <p style={{fontSize: 16, color: '#898484', textAlign: 'justify'}}>
              <strong>Select Your recipients</strong> will be strictly from your existing contact on
              your workspace e.g Customers, Company and Leads.
            </p>
            <p style={{fontSize: 16, color: '#898484', textAlign: 'justify'}}>
              You can create a list from each of your contacts on your workspace and save them for
              next time.
            </p>
            <p style={{fontSize: 16, color: '#898484', textAlign: 'justify'}}>
              Each recipients will be verified before being added to the campaign. They must meet
              your criteria for this campaign.
            </p>
          </div>
        </div>

        <div className='col-lg-6 col-12'>
          <form className='row g-3'>
            <div className='form-group mb-3'>
              <label style={{color: '#4A4747', fontSize: 16}}>Select Recipients*</label>
              <select
                className='form-control form-select'
                value={selectedOption}
                onChange={handleOptionChange}
              >
                <option value={''}>Select Recipient From</option>
                {['All', 'Customers', 'Leads', 'Companies'].map((e, index) => (
                  <option value={e} key={index}>
                    {e}
                  </option>
                ))}
              </select>
              {recipientError && <p style={{color: 'red', fontSize: 12}}>{recipientError}</p>}
            </div>
            <div className='form-group mb-3'>
              <label style={{color: '#4A4747', fontSize: 16}}>Message to Recipient*</label>
              <textarea
                type='text'
                style={{height: 200}}
                className='form-control'
                placeholder='Campaign Message'
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              />
              {messageError && <p style={{color: 'red', fontSize: 12}}>{messageError}</p>}
            </div>

            <div className='d-flex justify-content-end mt-3'>
              <button
                type='button'
                disabled={!campaignData || checkedRecipientIds.length === 0 || message.trim() === ''}
                onClick={handleNextClick}
                className='btn'
                style={{
                  padding: '10px 70px',
                  borderRadius: 20,
                  backgroundColor: '#00B649',
                  color: 'white',
                  marginTop: 10,
                }}
              >
                Next
              </button>
            </div>
          </form>
        </div>
      </div>

      {isModalOpen && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <div
            style={{
              backgroundColor: 'white',
              padding: 20,
              borderRadius: 10,
              width: '50%',
              maxWidth: 600,
              position: 'relative',
            }}
          >
            <button
              onClick={()=>{closeModal();setCheckedRecipientIds([])}}
              style={{
                position: 'absolute',
                top: 10,
                right: 10,
                background: 'none',
                border: 'none',
                fontSize: 20,
                cursor: 'pointer',
              }}
            >
              &times;
            </button>
            <h3 style={{textAlign: 'center'}}>Select Recipients</h3>
            <div style={{marginBottom: 20}}>
              {recipients?.length > 0 && (
                <input
                  type='text'
                  placeholder='Search...'
                  value={searchQuery}
                  onChange={handleSearchChange}
                  style={{
                    width: '100%',
                    padding: 10,
                    borderRadius: 5,
                    border: '1px solid #ccc',
                    marginBottom: 10,
                  }}
                />
              )}
              <div
                style={{
                  maxHeight: 300,
                  overflowY: 'auto',
                  border: '1px solid #ccc',
                  borderRadius: 5,
                }}
              >
                {currentRecipients.length > 0 ? (
                  currentRecipients.map((recipient) => (
                    <div
                      key={recipient.id}
                      style={{
                        marginLeft:20,
                        marginRight:20,
                        padding: 10,
                        borderBottom: '1px solid #eee',
                        display: 'flex',
                        justifyContent: 'space-between',
                      }}
                    >
                      <div>
                        <input
                          type='checkbox'
                          id={`recipient-${recipient.id}`}
                          value={recipient.id}
                          checked={checkedRecipientIds.includes(recipient.id)}
                          onChange={() => handleRecipientToggle(recipient.id)}
                        />
                        <label htmlFor={`recipient-${recipient.id}`} style={{marginLeft: 10}}>
                          {recipient.name}
                        </label>
                      </div>
                      <label htmlFor={`recipient-${recipient.id}`} style={{marginLeft: 10}}>
                        {campaignData.route ==="1" ? recipient?.email : recipient?.phone}
                      </label>
                    </div>
                  ))
                ) : (
                  <p style={{textAlign: 'center', padding: 10}}>No recipients found.</p>
                )}
              </div>
              <div style={{display: 'flex', justifyContent: 'center', marginTop: 10}}>
                {renderPageNumbers()}
              </div>
            </div>
            {recipients?.length > 0 && (
              <div style={{display: 'flex', justifyContent: 'center'}}>
                <button
                  onClick={handleCreateList}
                  style={{
                    padding: '10px 60px',
                    borderRadius: 100,
                    backgroundColor: '#343535',
                    color: 'white',
                    border: 'none',
                    fontSize: 12,
                  }}
                >
                  Create List
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  )
}
